import "core-js/modules/es6.number.constructor.js";
import '@web/shared-digital-library/icons/svg-originals/chevron-left.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
var NavItemBranch = function NavItemBranch() {
  return import('./NavItemBranch.vue');
};
var NavItemLeaf = function NavItemLeaf() {
  return import('./NavItemLeaf.vue');
};
var NavItemFolders = function NavItemFolders() {
  return import('./NavItemFolders.vue');
};
var NavItemFlat = function NavItemFlat() {
  return import('./NavItemFlat.vue');
};
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
export default {
  name: 'NavItemTree',
  components: {
    MdmIcon: MdmIcon,
    NavItemBranch: NavItemBranch,
    NavItemLeaf: NavItemLeaf,
    NavItemFolders: NavItemFolders,
    NavItemFlat: NavItemFlat,
    MdmLink: MdmLink
  },
  props: {
    level: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: '#'
    },
    items: {
      type: Array,
      required: true
    },
    mea: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    withColor: {
      type: Boolean,
      default: false
    },
    isMenuOpened: {
      type: Boolean,
      default: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    branches: function branches() {
      return this.$refs['nav-item-branch'] || [];
    }
  },
  methods: {
    isScrambleTransformation: function isScrambleTransformation(item) {
      return !!(item.isScrambleLink || this.isScrambleLink);
    },
    itemClass: function itemClass(type) {
      if (type === 'card') {
        return 'pb-3';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length > 1) {
        return null;
      }
      return 'item';
    },
    seeMoreClass: function seeMoreClass(type) {
      if (type === 'cardsList') {
        return 'pb-3';
      }
      if (type === 'wrapper' && this.items.length > 1 && this.items.every(function (i) {
        return i.type === 'linksList';
      })) {
        return null;
      }
      return 'item';
    },
    componentName: function componentName(type) {
      if (type === 'link' || type === 'card') {
        return 'nav-item-leaf';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length > 1) {
        return 'nav-item-folders';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length === 1) {
        return 'nav-item-flat';
      }
      return 'nav-item-branch';
    },
    close: function close() {
      this.branches.forEach(function (branch) {
        return branch.close();
      });
    }
  }
};